<div class="mat-form-field-infix day-month-picker">
  <input matInput [matDatepicker]="picker" [formControl]="formControl">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="dayMonthPickerHeader"></mat-datepicker>
</div>